import { ShowButton, ShowButtonProps } from '@refinedev/antd';
import { useGo, useResourceParams } from '@refinedev/core';
import type { PointerEvent } from 'react';

import { usePermissionContext } from '@/contexts/PermissionContext';

interface ProtectedShowButtonProps extends ShowButtonProps {
  keepQuery?: boolean;
}

const ProtectedShowButton = ({
  keepQuery = false,
  recordItemId,
  resource: resourceNameFromProps,
  meta,
  onClick,
  ...rest
}: ProtectedShowButtonProps) => {
  const { hasPermission } = usePermissionContext();
  const go = useGo();
  const { resource, identifier } = useResourceParams({ resource: resourceNameFromProps });
  const resolvedResource = resourceNameFromProps ?? identifier ?? resource?.name;
  const canKeepQuery = keepQuery && resolvedResource && recordItemId != null;
  const handleClick = (event: PointerEvent<HTMLButtonElement>) => {
    onClick?.(event);
    if (!canKeepQuery) {
      return;
    }

    go({
      to: { resource: resolvedResource, action: 'show', id: recordItemId, meta },
      options: { keepQuery: true },
    });
  };

  return hasPermission('show') ? (
    <ShowButton
      className="ProtectedShowButton"
      recordItemId={recordItemId}
      resource={resourceNameFromProps}
      meta={meta}
      onClick={canKeepQuery ? handleClick : onClick}
      {...rest}
    />
  ) : null;
};

export default ProtectedShowButton;
